import { Add, MoreHoriz, ReadMore, Visibility } from "@mui/icons-material";
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useRef, useState } from "react";
import { BaseModalComponent } from "../../common/BaseModalComponent";
import { colors, alphaVar } from "../../ui/colors";
import { SASMenuStyles } from "../../ui/styles/inputStyles";
import { InvoicesTable } from "./InvoicesTable";

export const InvoiceActionsMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const openMenu = (e) => setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const seeInvoicesTriggerRef = useRef(null);
  const createInvoiceTriggerRef = useRef(null);

  const fire = (ref) => {
    ref.current?.click?.();
    setTimeout(closeMenu, 0);
  };

  return (
    <>
      <IconButton
        onClick={openMenu}
        sx={{
          color: colors.gray[300],
          transition: "all 0.2s ease-in-out",
          "&:hover": { backgroundColor: alphaVar(colors.orange.base, 0.08), color: "var(--fx-surface-text, #0F172A)" },
        }}
      >
        <ReadMore />
      </IconButton>

      {/* Menu */}
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={closeMenu} sx={SASMenuStyles}>
        <MenuItem onClick={() => fire(seeInvoicesTriggerRef)}>
          <ListItemIcon>
            <Visibility fontSize="small" />
          </ListItemIcon>
          <ListItemText>See Invoices</ListItemText>
        </MenuItem>

        {/* <MenuItem onClick={() => fire(createInvoiceTriggerRef)}>
          <ListItemIcon>
            <Add fontSize="small" />
          </ListItemIcon>
          <ListItemText>Create New Invoice</ListItemText>
        </MenuItem> */}
      </Menu>

      {/* Hidden modals */}
      <BaseModalComponent
        modalLabel="See invoices"
        modalKey="Dashboard-Invoices-See"
        elementTrigger={<button ref={seeInvoicesTriggerRef} type="button" style={{ position: "absolute", left: -99999, top: -99999 }} />}
      >
        <InvoicesTable />
      </BaseModalComponent>

      <BaseModalComponent
        modalLabel="Create new invoice"
        modalKey="Dashboard-Invoices-Create"
        elementTrigger={<button ref={createInvoiceTriggerRef} type="button" style={{ position: "absolute", left: -99999, top: -99999 }} />}
      >
        <Box p={2}>Create invoice placeholder</Box>
      </BaseModalComponent>
    </>
  );
};
